import { isEqual } from "lodash"
import cloneDeep from "lodash/cloneDeep"
import { useCallback, useEffect, useReducer, useRef, useState } from "react"
// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime"
import TableWrapper from "../Hocs/TableWrapper"
import { Table as BasicTable } from "../Table"
import {
  HeaderTurboTable,
  TableDateRange,
  TableInputNumberRange,
  TableInputText,
  TableMultiSelect,
  TableSelect,
} from "./components"
import {
  initialState,
  queryReducer,
  queryType,
  setStringSortOrder,
  toLocalFormat,
} from "./helpers"
import useDragScroll from "./helpers/useDragScroll"

const TurboTable = ({
  onSelectionChange,
  value,
  totalRecords,
  columns,
  className,
  selectionMode,
  isLoading,
  setQueryState,
  showFilter,
  showSelectTable,
  showSelectColumns,
  currentTable,
  setCurrentTable,
  tableOptions,
  reorderableColumns,
  resizableColumns,
  onColReorder,
  onColumnResizeEnd,
  paginator,
  removableSort,
  onRowClick,
  onRowToggle,
  globalFilter,
  tableTitle,
  showHeader = true,
  HeaderCustomComponent,
  multiple,
  scrollable,
  frozenWidth,
  initialQueryState,
  scrollHeight,
  showTabs,
  tabsOptions,
  setActiveTab,
  setIsFiltering,
  stateKey,
  virtualScroll,
  virtualRowHeight,
  onVirtualScroll,
  emptyMessage,
  selected,
  handleSelectedFromParent,
  virtualScrollDelay,
  showSelectionElement,
  onRowSelect,
  onRowUnselect,
  skeletonLoader = false,
  dataKey,
  editMode,
  editingRows,
  rowEditorValidator,
  onRowEditInit,
  onRowEditSave,
  onRowEditCancel,
  onRowEditChange
}: any) => {
  const dtRef = useRef(null)
  useDragScroll({
    sliderRef: dtRef,
  })
  const [filtersSelected, setfiltersSelected] = useState()
  const [tableFilters, setTableFilters] = useState({})
  const [selectedColumns, setSelectedColumns] = useState(columns)
  const [sortField, setSortField] = useState()
  const [sortOrder, setSortOrder] = useState()
  const [rowsSelected, setRowsSelected] = useState(selected)
  const [filterable, setFilterable] = useState(false)
  const [queryState, dispatch] = useReducer(
    queryReducer,
    initialQueryState || initialState()
  )
  const _onSelectionChange = (row: any) => {
    setRowsSelected(row)
    onSelectionChange && onSelectionChange(row)
  }
  const _onColReorder = (e: any) => {
    e.columns
    const newSelectedColumns = e.columns.map((rc: any) => selectedColumns.find((sc: any) => rc.key.includes(sc.key))
    )
    setSelectedColumns(newSelectedColumns)
    if (onColReorder) {
      onColReorder(newSelectedColumns)
    }
  }
  const _onVirtualScroll = (e: any) => {
    if (
      (queryState === null || queryState === void 0
        ? void 0
        : queryState.skipCount) !==
      (e === null || e === void 0 ? void 0 : e.first)
    ) {
      dispatch({
        payload: {
          skipCount: e.first,
        },
        type: queryType.SKIP,
      })
    }
    if (onVirtualScroll) {
      onVirtualScroll(e)
    }
  }
  const _onColumnResizeEnd = (e: any) => {
    if (onColumnResizeEnd) {
      onColumnResizeEnd(e)
    }
  }
  const onColumnToggle = (value: any) => {
    const selColumns = value
    const orderedSelectedColumns = columns.filter((col: any) => selColumns.some((sCol: any) => sCol.field === col.field)
    )
    setSelectedColumns(orderedSelectedColumns)
  }
  const toggleFilters = (andClearFilters = false) => {
    let _a
    if (andClearFilters) {
      setFilters({})
      onSort({ sortField: "", sortOrder: 0, multiSortMeta: null })
    }
    ;(_a = dtRef === null || dtRef === void 0 ? void 0 : dtRef.current) ===
      null || _a === void 0
      ? void 0
      // @ts-expect-error TS(2339): Property 'reset' does not exist on type 'never'.
      : _a.reset()
    let newSelectedColumns = cloneDeep(selectedColumns)
    newSelectedColumns =
      newSelectedColumns === null || newSelectedColumns === void 0
        ? void 0
        : newSelectedColumns.map((element: any) => {
            if ("filter" in element) {
              element.filter = !andClearFilters && !filterable
            }
            return element
          })
    setFilterable(!andClearFilters && !filterable)
    setIsFiltering && setIsFiltering(!andClearFilters && !filterable)
    setSelectedColumns(newSelectedColumns)
  }
  const filterTable = useCallback(() => {
    if (filtersSelected) {
      let newState = ""
      // @ts-expect-error TS(2339): Property 'forEach' does not exist on type 'never'.
      filtersSelected.forEach((el: any) => {
        newState += el.query
      })
      dispatch({ payload: { params: newState }, type: queryType.PARAMS })
    }
  }, [filtersSelected])
  useEffect(() => {
    filterTable()
  }, [filterTable])
  useEffect(() => {
    if (columns.length) {
      setSelectedColumns(columns)
    }
  }, [columns])
  useEffect(() => {
    setQueryState &&
      setQueryState((qs: any) => {
        if (!isEqual(qs, queryState)) {
          return queryState
        }
      })
  }, [queryState])
  useEffect(() => {
    if (columns) {
      columns.forEach((column: any) => {
        if (column.customFilter) {
          const {
            options: filterOptions,
            name: filterName,
            itemTemplate,
            type,
          } = column === null || column === void 0
            ? void 0
            : column.customFilter
          switch (type) {
            case "multiselect": {
              column.filterElement = _jsx(
                TableMultiSelect,
                {
                  options: filterOptions,
                  itemTemplate,
                  onChange: (selectedIds: any) => {
                    // @ts-expect-error TS(2531): Object is possibly 'null'.
                    dtRef.current.filter(selectedIds, filterName, "in")
                  },
                },
                void 0
              )
              break
            }
            case "select": {
              column.filterElement = _jsx(
                TableSelect,
                {
                  options: filterOptions,
                  itemTemplate,
                  onChange: (selectedId: any) => {
                    // @ts-expect-error TS(2531): Object is possibly 'null'.
                    dtRef.current.filter(selectedId, filterName, "in")
                  },
                },
                void 0
              )
              break
            }
            case "date": {
              column.filterElement = _jsx(
                TableDateRange,
                {
                  options: filterOptions,
                  itemTemplate,
                  onChange: (dateRange: any) => {
                    // @ts-expect-error TS(2531): Object is possibly 'null'.
                    dtRef.current.filter(
                      (dateRange && [
                        toLocalFormat(dateRange[0]),
                        toLocalFormat(dateRange[1]),
                      ]) ||
                        "",
                      `${filterName}`,
                      "range"
                    )
                  },
                },
                void 0
              )
              break
            }
            case "number": {
              column.filterElement = _jsx(
                TableInputNumberRange,
                {
                  onChange: (numberRange: any) => {
                    if (numberRange.some((number: any) => number !== null))
                      // @ts-expect-error TS(2531): Object is possibly 'null'.
                      dtRef.current.filter(
                        numberRange || "",
                        `${filterName}`,
                        "range"
                      )
                  },
                },
                void 0
              )
              break
            }
            case "input": {
              column.filterElement = _jsx(
                TableInputText,
                {
                  onChange: (value: any) => {
                    // @ts-expect-error TS(2531): Object is possibly 'null'.
                    dtRef.current.filter(value, filterName, "in")
                  },
                },
                void 0
              )
              break
            }
            default:
              break
          }
        }
        return column
      })
      const newSelectedColumsn = cloneDeep(columns)
      setSelectedColumns(newSelectedColumsn)
    }
  }, [columns])
  const onPage = (e: any) => {
    if (
      (queryState === null || queryState === void 0
        ? void 0
        : queryState.skipCount) !==
      (e === null || e === void 0 ? void 0 : e.first)
    ) {
      dispatch({
        payload: {
          skipCount: e.first,
        },
        type: queryType.SKIP,
      })
    }
  }
  const onChangeRowsPerPage = (e: any) => {
    dispatch({
      payload: {
        maxResult: e,
      },
      type: queryType.MAXRES,
    })
  }
  const onSort = (e: any) => {
    setSortField(e.sortField)
    setSortOrder(e.sortOrder)
    if (
      !e.sortField &&
      (initialQueryState === null || initialQueryState === void 0
        ? void 0
        : initialQueryState.sortingCriteria)
    ) {
      dispatch({
        payload: {
          sortingCriteria:
            initialQueryState === null || initialQueryState === void 0
              ? void 0
              : initialQueryState.sortingCriteria,
        },
        type: queryType.SORT,
      })
      return
    }
    const sortStringOrder = setStringSortOrder(e.sortOrder)
    if (!sortStringOrder) {
      dispatch({
        payload: {
          sortingCriteria: null,
        },
        type: queryType.SORT,
      })
      return
    }
    dispatch({
      payload: {
        sortingCriteria: {
          property: e.sortField,
          sort: sortStringOrder,
        },
      },
      type: queryType.SORT,
    })
  }
  const getFieldRangeFilterValue = (value: any, fieldName: any, filterName: any) => {
    return value ? `&${fieldName}${filterName}=${value}` : ""
  }
  const getQuery = (field: any, value: any, matchMode: any) => {
    if (matchMode === "range") {
      return `${getFieldRangeFilterValue(
        value[0],
        field,
        "LowerLimit"
      )}${getFieldRangeFilterValue(value[1], field, "UpperLimit")}`
    }
    return Array.isArray(value)
      ? `&${field}=${value.join(`&${field}=`)}`
      : `&${field}=${value}`
  }
  const setFilters = (newFilters: any) => {
    const fields = Object.keys(newFilters)
    const parsedFilters = fields.map((field, index) => {
      const { value, matchMode } = newFilters[field]
      return {
        label: field,
        value: index,
        query: getQuery(field, value, matchMode),
      }
    })
    // @ts-expect-error TS(2345): Argument of type '{ label: string; value: number; ... Remove this comment to see the full error message
    setfiltersSelected(parsedFilters)
    setTableFilters(newFilters)
  }
  return _jsx(
    TableWrapper,
    {
      data: value || [],
      children: _jsx(
        BasicTable,
        {
          isLoading,
          columns: selectedColumns,
          value,
          totalRecords,
          removableSort,
          sortField,
          sortOrder,
          first: setQueryState && queryState.skipCount,
          rows: setQueryState && queryState.maxResult,
          header: showHeader
            ? _jsx(
                HeaderTurboTable,
                {
                  selectedColumns,
                  columns,
                  onColumnToggle,
                  toggleFilters,
                  currentTable,
                  setCurrentTable,
                  tableOptions,
                  showFilter,
                  showSelectTable,
                  showSelectColumns,
                  tableTitle,
                  showTabs,
                  tabsOptions,
                  setActiveTab,
                  CustomComponent: HeaderCustomComponent,
                  dtRef,
                },
                void 0
              )
            : null,
          onPage,
          onSort,
          paginator,
          rowsPerPageOptions: [2, 5, 10, 20, 50, 100],
          selectionMode,
          onSelectionChange: (e: any) => _onSelectionChange(e.value),
          className,
          dtRef,
          filterDelay: 300,
          setFilters,
          filters: tableFilters,
          reorderableColumns,
          resizableColumns,
          onColReorder: _onColReorder,
          onColumnResizeEnd: _onColumnResizeEnd,
          onRowClick,
          onRowToggle,
          globalFilter,
          onChangeRowsPerPage,
          multiple,
          selected: handleSelectedFromParent ? selected : rowsSelected,
          scrollable,
          frozenWidth,
          scrollHeight,
          stateKey,
          virtualScroll,
          virtualRowHeight,
          onVirtualScroll: _onVirtualScroll,
          virtualScrollDelay,
          showSelectionElement,
          emptyMessage,
          onRowSelect,
          onRowUnselect,
          skeletonLoader,
          dataKey,
          editMode,
          editingRows,
          rowEditorValidator,
          onRowEditInit,
          onRowEditSave,
          onRowEditCancel,
          onRowEditChange,
        },
        void 0
      ),
    },
    void 0
  );
}
export default TurboTable
